import { VersionedAbstractEntity } from "../VersionedAbstractEntity";
export default class ProtocolType extends VersionedAbstractEntity {
    name;
    icon;
    contentTypes = [];
    showPositionInTable;
    showCogSogInTable;
    elementForType;
    elementForDetails;
    isReport;
    showPassedTimeZones;
    showDispatchBox;
    showUTC;
    nonConfidential;
    takeoverConfigs = [];
    constructor(protocolType = {}) {
        super();
        Object.assign(this, protocolType);
    }
}
//# sourceMappingURL=ProtocolType.js.map